import { storageService } from '~/services'

export const state = () => ({
  status: null,
  deeplink: null,
  isDeeplinkLoading: false,
  diiaStatus: null,
  diiaDocuments: null,
  selectedDiiaDocument: {
    is_available_for_user: false,
    scope: null,
  },
  missingDiiaDocuments: [],
})

export const mutations = {
  setUserStatus(state, data) {
    state.status = data
    if (state.deeplink === null && data?.deeplink) {
      state.deeplink = data
    }
  },

  setDeeplink(state, data) {
    state.deeplink = data
  },

  set_isDeeplinkLoading(state, value) {
    state.isDeeplinkLoading = value
  },

  setDiiaStatus(state, data) {
    state.diiaStatus = data
  },

  set_diiaDocuments(state, data) {
    state.diiaDocuments = [...data]
  },

  set_selectedDiiaDocument(state, diiaDocument) {
    state.selectedDiiaDocument = { ...diiaDocument }
  },

  set_missingDiiaDocuments(state, diiaDocuments) {
    state.missingDiiaDocuments = [...diiaDocuments]
  },
}

export const actions = {
  async userStatus({ commit }) {
    const res = await this.$api.diia.getUserStatusDiia()
    commit('setUserStatus', res.data)
  },

  async deeplink({ commit }, { platform, scope } = { platform: null, scope: null }) {
    commit('set_isDeeplinkLoading', true)
    const res = await this.$api.diia.getDeeplinkDiia({ platform, scope })
    storageService.setItem('diiaDeepLink', res.data)
    commit('setDeeplink', res.data)
    commit('set_isDeeplinkLoading', false)
  },

  async diiaStatus({ commit }) {
    const res = await this.$api.diia.getStatusDiia()
    commit('setDiiaStatus', res.data)
  },

  async act_fetchDiiaDocuments({ commit }) {
    const { data } = await this.$api.diia.getSharingScope()

    if (Array.isArray(data)) {
      commit('set_diiaDocuments', data)
    }

    return data
  },

  act_selectDiiaDocument({ commit }, diiaDocument) {
    commit('set_selectedDiiaDocument', diiaDocument)
  },

  act_getMissingDiiaDocuments({ commit }) {
    try {
      const missingDiiaDocuments = storageService.getItem('diiaMissingDocuments')
      const parsedDocuments = JSON.parse(missingDiiaDocuments)

      if (Array.isArray(parsedDocuments)) {
        commit('set_missingDiiaDocuments', parsedDocuments)
      }
    }
    catch (error) {
      console.error(error)
    }
  },

  act_setMissingDiiaDocument({ commit, getters }, diiaDocumentType) {
    try {
      if (typeof diiaDocumentType !== 'string') throw new Error('Diia document type must be a string')
      const twentyFourHourInMilliseconds = 24 * 3600 * 1000
      const expireDate = new Date(Date.now() + twentyFourHourInMilliseconds)
      const missingDiiaDocuments = [...getters.get_missingDiiaDocuments, diiaDocumentType]
      const jsonDocuments = JSON.stringify(missingDiiaDocuments)
      storageService.setItem('diiaMissingDocuments', jsonDocuments, expireDate)
      commit('set_missingDiiaDocuments', missingDiiaDocuments)
    }
    catch (error) {
      console.error(error)
    }
  },
}

export const getters = {
  getUserStatus: state => state.status,
  getDeeplink: state => state.deeplink,
  get_isDeeplinkLoading: state => state.isDeeplinkLoading,
  getDiiaStatus: state => state.diiaStatus,
  get_diiaDocuments: state => state.diiaDocuments,
  get_selectedDiiaDocument: state => state.selectedDiiaDocument,
  get_missingDiiaDocuments: state => state.missingDiiaDocuments,
}
